import { useQuery } from "react-query";
import { getJSON } from "../../../../http";
import { SavedExportSettingsResponse } from "./savedExportSettings.types";
import { savedExportSettingsKey } from "./savedExportSettings.constants";
import { savedExortSettings } from "../../bulkBaseUrl";

export function useSavedExportSettingsQuery() {
  const { isLoading, error, data, refetch } = useQuery(savedExportSettingsKey, () =>
    getJSON<SavedExportSettingsResponse>(savedExortSettings)
  );
  return {
    isSavedExportSettingsLoading: isLoading,
    savedExportSettingsError: error,
    savedExportSettings: data,
    refetchSavedExportSettings: refetch,
  };
}
